import { render, staticRenderFns } from "./ShippingUnitsGrid.vue?vue&type=template&id=1813ae01&scoped=true"
import script from "./ShippingUnitsGrid.vue?vue&type=script&lang=js"
export * from "./ShippingUnitsGrid.vue?vue&type=script&lang=js"
import style0 from "./ShippingUnitsGrid.vue?vue&type=style&index=0&id=1813ae01&prod&scoped=true&lang=css"
import style1 from "./ShippingUnitsGrid.vue?vue&type=style&index=1&id=1813ae01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813ae01",
  null
  
)

export default component.exports